import { oneDriveProviderName } from './fileProviderSelectors.locstring.json';
import loc, { format } from 'owa-localize';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { assertNever } from 'owa-assert';

import { getStore } from '../store/store';
import { isGroupProviderViewState, isOneDriveProViewState } from '../utils/typeGuards';

export function getFileProviderName(): string {
    const store = getStore();

    if (isGroupProviderViewState(store.providerViewState)) {
        return store.providerViewState.groupDisplayName;
    } else if (isOneDriveProViewState(store.providerViewState)) {
        return format(loc(oneDriveProviderName), getCompanyName());
    }

    return assertNever(store.providerViewState);
}

export function isChangeLocationAllowedForProvider(): boolean {
    const store = getStore();

    if (isGroupProviderViewState(store.providerViewState)) {
        return false;
    } else if (isOneDriveProViewState(store.providerViewState)) {
        return true;
    }

    return assertNever(store.providerViewState);
}

function getCompanyName(): string {
    return getUserConfiguration().SessionSettings.CompanyName;
}
